import { enqueueSnackbar } from "notistack";
import apiConfig from "../../../services/apiManager/apiConfig";
import {
  getBasicAuthRequest,
  getRequest,
  postRequest,
} from "../../../services/apiManager/apiRequests";
import storePersist, { localConstant } from "../../../services/localStorage";
import {
  SIGN_UP_LOADING_REQUEST,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILED_REQUEST,
  GET_ALL_STATE_LIST,
  RESEND_EMAIL_REQUEST,
  RESEND_EMAIL_FAILED,
  RESEND_EMAIL_SUCCESS,
  G2_CUSTOMER_SIGNUP_REQUEST,
} from "../constants";
import Cookies from "js-cookie";
import SnackbarConfig from "../../../utils/snackbarConfig";

export const checkUserExistsbyemail =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      const response = await getRequest(apiConfig.userExistsbyemail, params);
      if (response) {
        callback(response);
      } else {
        callback({});
      }
    } catch (error) {
      callback(error?.response?.data);
    }
  };

export const signUpReuest =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      const response = await postRequest(apiConfig.createUser, params);
      if (response?.data) {
      } else {
        callback({});
      }
    } catch (error) {
      callback({});
    }
  };

export const stateListRequest =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      const response = await getRequest(apiConfig.getStateList, params);
      if (response?.resultObject) {
        storePersist.set(localConstant.STATE_LIST, response?.resultObject);
        dispatch({
          type: GET_ALL_STATE_LIST,
          payload: response?.resultObject,
        });
        callback(response);
      } else {
        enqueueSnackbar("Error fetching states", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
        callback({});
      }
    } catch (error) {
      enqueueSnackbar("Error fetching states", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
    }
  };

export const phoneValidationRequest =
  (number, countryCode, params, callback = () => {}) =>
  async (dispatch) => {
    try {
      const apiUrl = `${apiConfig.countryPhoneValidationRequest}/${countryCode}`;
      const attachedaNumberUrl = `${apiUrl}${number}`;
      dispatch({
        type: SIGN_UP_LOADING_REQUEST,
        payload: { isLoading: true },
      });
      const response = await getRequest(attachedaNumberUrl, params);
      if (response) {
        callback(response);
      } else {
        enqueueSnackbar("Failed to validate phone", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
        callback({});
      }
      dispatch({
        type: SIGN_UP_FAILED_REQUEST,
        payload: {},
      });
    } catch (error) {
      callback(error);
      dispatch({
        type: SIGN_UP_FAILED_REQUEST,
        payload: {},
      });
    }
  };

export const postalCodeValidationRequest =
  (data, callback = () => {}) =>
  async (dispatch) => {
    try {
      const response = await postRequest(apiConfig.addressValidation, data);
      if (response) {
        callback(response);
      } else {
        callback({});
      }
    } catch (error) {
      enqueueSnackbar("Invalid country, state and zipcode combination", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
    }
  };

export const signUpRequest =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: SIGN_UP_LOADING_REQUEST,
        payload: { isLoading: true },
      });
      const response = await postRequest(apiConfig.signupUser, params);
      if (response?.user) {
        enqueueSnackbar("Email verification link sent successfully", {
          variant: "success",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
        dispatch({
          type: SIGN_UP_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        enqueueSnackbar("Failed to sign up user", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
        dispatch({
          type: SIGN_UP_FAILED_REQUEST,
          payload: { isLoading: false },
        });
        callback({});
      }
      dispatch({
        type: SIGN_UP_FAILED_REQUEST,
        payload: { isLoading: false },
      });
    } catch (error) {
      callback({});
      if (error?.response?.data?.error_description) {
        enqueueSnackbar(error?.response?.data?.error_description, {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      }
      dispatch({
        type: SIGN_UP_FAILED_REQUEST,
        payload: { isLoading: false },
      });
    }
  };

export const resendVerificationEmailRequest =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESEND_EMAIL_REQUEST,
        payload: { isLoading: true },
      });
      const response = await postRequest(
        apiConfig.resendVerificationEmail,
        params,
      );
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
        dispatch({
          type: RESEND_EMAIL_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        enqueueSnackbar("Failed to send email for verification", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
        dispatch({
          type: RESEND_EMAIL_FAILED,
          payload: { isLoading: false },
        });
        callback({});
      }
      dispatch({
        type: RESEND_EMAIL_FAILED,
        payload: { isLoading: false },
      });
    } catch (error) {
      enqueueSnackbar("Failed to send email for verification", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
      dispatch({
        type: RESEND_EMAIL_FAILED,
        payload: { isLoading: false },
      });
    }
  };

export const basicAuthRequest =
  (data, callback = () => {}) =>
  async (dispatch) => {
    try {
      const response = await getBasicAuthRequest(
        apiConfig.commonApis.basicAuth,
        data,
      );
      if (response?.basicAuth) {
        Cookies.set("basicAuth", response?.basicAuth);
        callback(response);
      } else {
        callback({});
      }
    } catch (error) {}
  };

export const verifyUserRequest =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      const verifyUserEmailURL = apiConfig.verifyUser + params;
      const verifyUserResponse = await getRequest(verifyUserEmailURL, {});
      callback(verifyUserResponse);
    } catch (error) {
      enqueueSnackbar("Failed to verify user", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback(error);
    }
  };

export const g2CustomerOrUserSignupParams = (data) => ({
  type: G2_CUSTOMER_SIGNUP_REQUEST,
  payload: data,
});

export const signUpRequestFromG2Portal =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: G2_CUSTOMER_SIGNUP_REQUEST,
        payload: { isLoading: true },
      });
      const g2SignUpRequestURL =
        apiConfig.g2CustomerOrUserSignup + params.userId;
      const response = await postRequest(g2SignUpRequestURL, params);
      callback(response);
    } catch (error) {
      enqueueSnackbar("Failed to register you account", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback(error);
    }
  };
